import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const authAPI = {
  register: ({ user, password }) =>
    api.post("/api/register", { user, password }),
  login: ({ user, password }) => api.post("/api/login", { user, password }),
  logout: () => api.post("/api/logout"),
  getMe: () => api.get("/api/me"),
  getMyOrgs: () => api.get("/api/my-orgs"),
  getCalendarVisibility: () => api.get("/api/calendar-visibility"),
};

export const agentCardsAPI = {
  getAll: () => api.get("/api/agent-cards"),
  get: (id) => api.get(`/api/agent-cards/${id}`),
  upsert: (data) => api.post("/api/agent-cards", data),
  delete: (id) => api.delete(`/api/agent-cards/${id}`),
};

export const legalAPI = {
  get: () => api.get("/api/legal"),
};

export const adminAPI = {
  listOrgs: () => api.get("/api/orgs"),
  createOrg: (data) => api.post("/api/register-org", data),
  updateOrg: (orgId, data) => api.put(`/api/orgs/${orgId}`, data),
  createAllowedUser: (data) => api.post("/api/allowed-users", data),
  listAllowedUsers: () => api.get("/api/allowed-users"),
};

export const crmAPI = {
  // Config
  getConfig: (orgId) => api.get(`/api/crm/${orgId}/config`),
  updateBasic: (orgId, data) => api.put(`/api/crm/${orgId}/basic`, data),
  updateSchedule: (orgId, data) => api.put(`/api/crm/${orgId}/schedule`, data),
  updateAppointments: (orgId, data) =>
    api.put(`/api/crm/${orgId}/appointments`, data),

  // Calendar Events
  getEvents: (orgId, params) => api.get(`/api/crm/${orgId}/events`, { params }),
  createEvent: (orgId, data) => api.post(`/api/crm/${orgId}/events`, data),
  cancelEvent: (orgId, eventId) =>
    api.post(`/api/crm/${orgId}/events/${eventId}/cancel`),
  blockDays: (orgId, data) =>
    api.post(`/api/crm/${orgId}/events/block-days`, data),
};

export const analyticsAPI = {
  // Fetch the single dashboard payload. Admins may pass any `org_id` (or
  // omit it for all orgs); non-admins are server-side pinned to their own
  // org regardless of what they send.
  getOverview: ({ range = "7d", orgId = null } = {}) =>
    api.get("/api/analytics/overview", {
      params: {
        range,
        ...(orgId == null ? {} : { org_id: orgId }),
      },
    }),
};

export const settingsAPI = {
  // Fetch the singleton platform settings (any authenticated user).
  getSettings: () => api.get("/api/platform-settings"),
  // Partial update — omitted fields are preserved; feature_flags is shallow-merged server-side.
  updateSettings: (data) => api.post("/api/platform-settings", data),
  // Convenience wrappers for the two independent UI controls.
  setActiveModel: (activeModel) =>
    api.post("/api/platform-settings", { active_model: activeModel }),
  setFeatureFlag: (key, enabled) =>
    api.post("/api/platform-settings", { feature_flags: { [key]: !!enabled } }),
};
export default api;
